import { useFormContext } from "react-hook-form";

import {
  CrossPartnerMarketingOptIn,
  PartnerPPAccept,
  StudentAddressCountry,
  StudentAddressCountryName,
  StudentAddressState,
  StudentAddressStateName,
  StudentAddressZipcode,
  StudentAge,
  StudentAgeName,
  StudentEmail,
  StudentFirstName,
  StudentLastName,
  StudentMiddleName,
  UnderAgeMarketingConsent,
} from "@up/application-fields";
import { isStrictUSStateByName } from "@up/data";

import type { GeoData } from "@up/data";
import type { ReactNode } from "react";

export function StudentInformationPage1({
  bottom,
  geo,
}: {
  bottom: () => ReactNode;
  geo: GeoData;
}) {
  const { watch } = useFormContext();

  const studentAge = watch(StudentAgeName);
  const studentCountry = watch(StudentAddressCountryName);
  const studentState = watch(StudentAddressStateName);

  const isIntl = geo.isIntl || studentCountry !== "United States";
  const IS_UNDER_18 = !studentAge || parseInt(studentAge) < 18;
  const SHOW_MARKETING_PROGRAM_CONSENT = isIntl ? true : IS_UNDER_18;
  const SHOW_CROSS_PARTNER_MARKETING_OPT_IN = (() => {
    const isStrictUSState =
      isStrictUSStateByName(studentState) || geo.isStrictUSState;

    if (isIntl) return false;
    if (isStrictUSState && IS_UNDER_18) return false;

    return true;
  })();

  return (
    <>
      <div className="grid-cols-3 gap-4 md:grid">
        <StudentFirstName />

        <StudentMiddleName />

        <StudentLastName />
      </div>

      <StudentEmail />

      <div className="md:grid-cols-3 md:gap-4 gap-6 grid mb-6">
        <div className="col-span-2">
          <StudentAddressCountry />
        </div>
        {studentCountry === "United States" && <StudentAddressState />}
      </div>

      <div className="flex gap-4">
        <StudentAddressZipcode />
        <StudentAge />
      </div>

      <div
        className={`${SHOW_MARKETING_PROGRAM_CONSENT || SHOW_CROSS_PARTNER_MARKETING_OPT_IN ? "kup-fieldset" : ""}`}
      >
        {SHOW_MARKETING_PROGRAM_CONSENT && <UnderAgeMarketingConsent />}
        {SHOW_CROSS_PARTNER_MARKETING_OPT_IN ? (
          <CrossPartnerMarketingOptIn />
        ) : null}
      </div>

      <PartnerPPAccept isDomestic={geo.isDomestic} />

      {bottom()}
    </>
  );
}
